import * as _ from "lodash";

import { ExtensionBase } from "../extensionBase";
import { ModelApi } from "../../api/modelApi";
import { viewerOptions } from "../../viewer";
import * as SmartDrawings from "../../smartDrawings";
import { UiUtils } from "../../common/uiUtils";
import { MeasurementDataPanel } from "./measurementDataPanel";

export class MeasurementDataExtension extends ExtensionBase {

    static extensionName = "MeasurementDataExtension";
  
    private subToolbar: Autodesk.Viewing.UI.ControlGroup;
    private measureButton: Autodesk.Viewing.UI.Button;

    private dataPanel: MeasurementDataPanel;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
        this.onModelRootLoaded = this.onModelRootLoaded.bind(this);

        this.dataPanel = new MeasurementDataPanel(viewer, viewer.container);
    }

    static registerExtension() {
        super.registerExtension(MeasurementDataExtension.extensionName, MeasurementDataExtension);
    }

    onToolbarCreated(): void {
        this.subToolbar = this.getControlGroup("SmartDrawings.Extensions");
        this.createUi();
    }

    private createUi() {
        if (this.checkUda()) {
            if (this.measureButton != null) {
                this.subToolbar.removeControl(this.measureButton);
            }

            this.measureButton = UiUtils.createButton({
                id: "SmartDrawings.MeasurementDataButton",
                tooltip: "View status data",
                iconClass: "ion-md-speedometer",
                onClick: () => {
                    this.dataPanel.setVisible(!this.dataPanel.isVisible());
                }
            });

            this.dataPanel.addVisibilityListener(visible => {
                this.measureButton.setState(visible
                    ? Autodesk.Viewing.UI.Button.State.ACTIVE
                    : Autodesk.Viewing.UI.Button.State.INACTIVE);
            });

            this.subToolbar.addControl(this.measureButton);
        }
    }

    private checkUda(): boolean {
        const { userDefinedAttributes } = viewerOptions;
        if (userDefinedAttributes == null)
            return false;

        if (userDefinedAttributes["MeasurementApi"]
            && userDefinedAttributes["MeasurementProjectId"]
            && userDefinedAttributes["MeasurementApiKey"]
            && userDefinedAttributes["MeasurementSourcePrefix"]
            && userDefinedAttributes["MeasurementApartmentPrefix"]) {
            return true;
        }

        return false;
    }

    onModelRootLoaded(): void {
    }

}